class FeatureFlags {
    constructor() {
        this.flags = {};
    }
    setFlags(flags) {
        for (const [key, value] of Object.entries(flags)) {
            this.flags[key] = value;
        }
    }
    getFlags() {
        return this.flags;
    }
}
const featureFlags = new FeatureFlags();
export const setFeatureFlags = (flags) => {
    featureFlags.setFlags(flags);
};
export const getFeatureFlags = () => {
    return featureFlags.getFlags();
};
export const hasFeatureFlags = () => {
    return Object.keys(featureFlags.getFlags()).length > 0;
};
